import type {ReactElement, ReactNode} from 'react';
import {useEffect} from 'react';
import Analytics from '@analytics/Analytics';
import {useLocation} from 'react-router-dom';

interface Props {
    children: ReactNode;
}

export default function TrackView(props: Props): ReactElement<Props> {
    const location = useLocation();
    useEffect(() => {
        Analytics.triggerPageView();
    }, [location.pathname]);

    return <>{props.children}</>;
}
